<template>
    <div class="g-container">
        <div class="aboutUs-banner">
            <img src="../detail/banner_kejian.png" style="width:100%" />
        </div>
        <div class="box-content">
            <div class="box-title">课件 > 视频上传</div>
            <div class="course-container">
                <div class="kejian">

                    <!-- <div class="album albumvideo">
                        <div>
                            <div id="filePicker" :class="'filePicker'+index" :style="item.videoForm.showVideoPath?'z-index:-1':''">

                            </div>
                            <div class="marTop" :style="{'z-index':index}">
                                <el-progress
                                        type="circle"
                                        v-bind:percentage="item.videoUploadPercent"
                                        style="margin-top:6px;">
                                </el-progress>
                                <p class="up-img"><i class="el-icon-upload2"></i></p>
                                <video :id="'V'+index"
                                        v-if="item.videoForm.showVideoPath !='' && !item.videoFlag"
                                        :src="item.videoForm.showVideoPath"
                                        class="avatar video-avatar"
                                        controls="controls">
                                    您的浏览器不支持视频播放
                                </video>
                                <vueupload
                                        ref="uploader"
                                        :uploadButton="'.filePicker'+index"
                                        url="/BackStage/FileUpload/UploadVideo"
                                        @fileChange="fileChange"
                                        @progress="(file, percent)=>{onProgress(file, percent, index)}"
                                        @success="(file, percent)=>{onSuccess(file, percent,index)}"
                                ></vueupload>
                            </div>
                        </div>
                    </div>-->
                    <uploader :options="options" :file-status-text="statusText" @file-success="fileSuccess"
                        @file-added="onFileAdded" @file-progress="onFileProgress" @file-error="onFileError"
                        @file-removed="onfileRemoved" class="uploader-example" ref="uploader">
                        <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                            <!--<uploader-list></uploader-list><i class="images" v-show='shipi' @click="Videoshow"></i>-->
                            <div v-for="txt, index in goodsVideo" class="martop50">
                                <h4>课件{{ index + 1 }}</h4>
                                <div><video :id="'iframeId' + index" autoplay :src="txt.url"></video></div>
                                <input type="text" placeholder="请输入课件名称" class="input_name" ref="titleInput"
                                    :id="'input' + index">
                                <img src="../detail/out.png" alt="" :id="'deleIco' + index" class="outs"
                                    @click="delvideo(txt, index)">
                                <p class="upload-btn" :id="'ploadBtn' + index"><a @click="oKUpload(txt, index)">上传课件</a></p>
                                <p class="uploadP" :id="'uploadId' + index"><img class="uploadoKImg"
                                        src="../detail/Ok.png" /><span>视频已提交成功</span> </p>
                            </div>

                        </uploader-drop>
                        <uploader-btn>
                            <p class="upload-btnP">
                                <img class="SC" src="../detail/SC.png" />
                                <span> 上传视频 </span>
                            </p>
                        </uploader-btn>
                    </uploader>
                </div>
                <!-- <p class="save-btn"><a @click="submitAdd">完成</a></p>-->
            </div>
        </div>

        <!--      @progress="onProgress" -->
        <div v-show="popup">
            <!--这里是要展示的内容层-->
            <div class="login">
                <div style="padding-bottom: 50px;text-align: center;"><i class="el-icon-loading"
                        style="font-size: 50px;"></i></div>
                {{ tishi_tit }}
            </div>
            <!--这里是半透明背景层-->
            <div class="over"></div>
        </div>
    </div>
</template>
<script>
import '../detail/upload.css';
import { UploadVideo, caseAdd, getUserInfo } from '../../../../api/index';
import vueupload from '../detail/uopload.vue';

export default {
    inject: ['reload'],
    components: {
        vueupload
    },
    data() {
        return {
            fileList: [],
            index: 2,
            formInfo: [
                {
                    caseName: '',
                    timeLong: '',
                    videoUploadPercent: 0,
                    videoFlag: false,
                    videoForm: { showVideoPath: '' }
                }],
            videoForm: { showVideoPath: '' },
            options: {
                target: '/Api/Common/VueUploadVideo', // '//jsonplaceholder.typicode.com/posts/',
                testChunks: false
            },
            attrs: {
                accept: 'image/*'
            },
            statusText: {
                success: '成功了',
                error: '出错了',
                uploading: '上传中',
                paused: '暂停中',
                waiting: '等待中'
            },
            goodsVideo: [],
            VideoIndex: 1,
            str1: '',
            shijian: '',
            popup: false,
            tishi_tit: '正在上传视频，请稍后。。。',
            file_tyle: 0
        }
    },
    computed: {
        uploader() {
            return this.$refs.uploader;
        }
    },
    methods: {
        //删除视频
        delvideo(txt, index) {
            this.goodsVideo.splice(index, 1)
            this.onfileRemoved()
        },
        async oKUpload(txt, index) {
            var inputTxt = document.getElementById('input' + index).value
            if (!inputTxt) {
                this.$message.error('课件标题不能为空');
                return;
            }
            var ploadBtn = document.getElementById('ploadBtn' + index).style.cssText = "display:none";
            var uploadId = document.getElementById('uploadId' + index).style.cssText = "display:block";
            var deleIco = document.getElementById('deleIco' + index).style.cssText = "display:none";
            document.getElementById('input' + index).setAttribute("readOnly", 'true')
            var res = await caseAdd({
                ForumsId: this.$router.currentRoute.params.id,
                Title: inputTxt,
                VideoUrl: this.str1[3],
                VideoTime: this.shijian
            })
            if (res.Type == 'Success') {
                this.$message({ showClose: true, message: '上传成功', type: 'success' });
            } else {
                this.$message.error(res.Content);
            }
        },
        fileSuccess(rootFile, file, message, chunk) {
            this.tishi_tit = '正在转码，请稍后。。。'
            var str = chunk.processedState.res
            this.str1 = str.split('"');
            var index = this.goodsVideo.length
            this.goodsVideo.push({ 'url': this.str1[3], 'caseName': '' })

            var that = this
            var t = setInterval(() => {
                if (document.getElementById("iframeId" + index)) {
                    //video标签出现,获取到时间，负责给对应数据并关闭定时器
                    var time = document.getElementById("iframeId" + index).duration
                    if (time) {
                        that.shijian = time
                        that.popup = false
                        clearInterval(t);
                    }
                }
            }, 500)
        },
        //文件添加时回调，这里可以做格式校验，md5计算  
        onFileAdded(file) {
            console.log('onFileAdded')
            this.popup = true
            if (file.size >= 1024 * 1024 * 200) {
                file.pause()
                this.$message({ showClose: true, message: '上传文件不可超过200MB' });
                return
            }
            var video = ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv']
            let file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
            for (var i = 0; i < video.length; i++) {
                const extension = file_type === video[i];
                console.log(video[i])
                if (extension) {
                    break;
                } else {
                    this.popup = false
                    this.file_tyle = -1
                    file.pause();
                }
            }
            if (this.file_tyle == -1) {
                this.$message({ showClose: true, message: "不支持当前后缀格式" });
            }

        },

        //删除视频
        onfileRemoved(file) {

        },
        //文件上传的过程中会频繁调用该函数
        onFileProgress(rootFile, file, chunk) {
            console.log('onFileProgress')
            console.log(rootFile, file, chunk)

        },
        //文件上传出错的回调
        onFileError(rootFile, file, msg, chunk) {
            console.log('onFileError')
            console.log(rootFile, file, msg, chunk)
        },
        fileComplete() {
        },
        VideoLoad(e) {
        },
        fileChange(file) {
            if (!file.size) return;
            this.fileList.push(file);
        },
        onProgress(file, percent, index) {
            console.log(percent)
            this.formInfo[index].videoUploadPercent = percent * 100;
            // $(`.file-${file.id} .progress`).css('width', percent * 100 + '%');
            // $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + '%');
        },
        onSuccess(file, response, index) {
            this.formInfo[index].videoForm.showVideoPath = response.Name;
            this.index = 10;
            //不断获取视频时间，直到获取到为止
            let that = this
            let t = setInterval(() => {
                if (document.getElementById("V" + index)) {
                    //video标签出现,获取到时间，负责给对应数据并关闭定时器
                    let time = document.getElementById("V" + index).duration
                    if (time) {
                        that.formInfo[index].timeLong = time;
                        clearInterval(t);
                    }

                }
            }, 500)
            if (response.needMerge) {
                let res = UploadVideo({
                    tempName: response.tempName,
                    fileName: file.name
                })
                let $fileStatus = $(`.file-${file.id} .file-status`);
                if (res.status === 0) {
                    $fileStatus.html('上传成功，转码中');
                } else if (res.status === 1) {
                    $fileStatus.html('上传失败');
                } else if (res.status === 2) {
                    $fileStatus.html('上传成功');
                }
            }
        },
        resume(file) {
            this.uploader.upload(file);
        },
        stop(file) {
            this.uploader.stop(file);
        },
        remove(file) {
            // 取消并中断文件上传
            this.uploader.cancelFile(file);
            // 在队列中移除文件
            this.uploader.removeFile(file, true);
            // 在ui上移除
            let index = this.fileList.findIndex(ele => ele.id === file.id);
            this.fileList.splice(index, 1);
        },
        fileSize(size) {
            return WebUploader.Base.formatSize(size);
        },
        fileCategory(ext) {
            let type = '';
            const typeMap = {
                //image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'],
                video: ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'],
                //text: ['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx']
            };
            Object.keys(typeMap).forEach((_type) => {
                const extensions = typeMap[_type];
                if (extensions.indexOf(ext) > -1) {
                    type = _type
                }
            });
            return type
        },

        // async submitAdd(){    // 完成提交
        //     console.log("开始提交");
        //     //构建表单数据
        //     let dataArr = this.formInfo.map(v=>{
        //         return {
        //             ForumsId: 123,
        //             Title: v.caseName,
        //             VideoUrl: v.videoForm.showVideoPath.replace(/\\/g,"\/"),
        //             VideoTime: v.timeLong
        //         }
        //     })
        //     //按顺序上传
        //      let s = async (i)=>{
        //         if(i < dataArr.length){
        //             let res =  await caseAdd(dataArr[i]);
        //             if(res.Type == 'Success'){
        //                 console.log(res.Content)
        //                 this.reload();
        //             }else{
        //                 this.reload();
        //                 console.log(res.Content)
        //             }
        //             await s(++i)
        //         }
        //     }
        //     await s(0);

        // }
    },
    created() {
    },
}

</script>
<style lang="scss" scoped>
#filePicker {
    position: relative;
    width: 160px;
    height: 160px;
    border: 1px solid #dedede;
    text-align: center;
    margin-top: 27px;
    margin-bottom: 50px;
    overflow: hidden;
    z-index: 5;
}

.marTop {
    margin-top: -210px;
    margin-left: 18px;
    position: relative;
    z-index: 2;
}

.up-img {
    position: absolute;
    width: 160px;
    text-align: center;
    height: 126px;
    line-height: 126px;
    top: 20px;
    left: -15px;
    z-index: 5;

    i {
        font-size: 36px;
    }
}

// video{
//     position: absolute;width: 160px;height: 160px;top: -1px;left: -17px;z-index: 10;
// }
.g-container {
    background: #f1f5f8;
    padding: 60px 0 45px;
}

.box-content {
    width: 1180px;
    height: auto;
    margin: 0 auto;
    padding: 15px 0;
}

.box-title {
    font-size: 14px;
    color: #333;
    line-height: 24px;
}

.course-container {
    background: #fff;
    margin: 15px auto 0;
    padding: 15px;
}

.kejian {
    margin: auto 0px;
}

.kejian h4 {
    font-size: 16px;
    color: #666;
    border-bottom: 1px solid #dedede;
    padding: 20px 0px 18px;
    margin-bottom: 24px;
}

input.input_name {
    width: 360px;
    height: 40px;
    ;
    border: 0px;
    border-radius: 4px;
    padding-left: 10px;
    background: #F5F5F5;
    font-family: Microsoft YaHei;
}

.input-img {
    width: 168px;
    height: 168px;
    position: relative;
    background: #F5F5F5;
    overflow: hidden;
    margin: 20px 0 30px;
    z-index: 1;
}

.input-img input {
    display: block;
    width: 168px;
    height: 168px;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
}

.input-img p {
    width: 164px;
    height: 164px;
    background: url("../detail/bofang.png");
    background-repeat: no-repeat;
    background-position: center;
}

.input-img span {
    position: absolute;
    top: 100px;
    display: block;
    width: 100%;
    text-align: center;
    color: #999999;
    font-size: 14px;
}

.upload-btn {
    widows: 100%;
    margin: 20px 0;
    text-align: center;
}

.upload-btn a {
    width: 90px;
    height: 34px;
    background: rgba(0, 183, 109, 1);
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    padding: 8px 17px;
}

.save-btn a {
    width: 220px;
    display: block;
    height: 48px;
    ;
    line-height: 48px;
    background: #4CDE9F;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border: 1px solid rgba(76, 222, 159, 1);
    margin: 80px auto 30px;
}

.Video_Uploads {
    position: absolute;
    color: #999999;
    font-size: 14px;
    bottom: 10px;
}

input::-webkit-input-placeholder {
    font-size: 16px;
}

.uploader-list {
    width: 164px;
}

.uploader-file-icon {
    display: none;
}

.uploader-file-info {
    font-size: 12px;
}

.box-content .uploader-file {
    height: 24px;
    line-height: 27px;
}

// .uploader-file{height: 26px;line-height: 30px;}
.uploader-file-size {
    display: none;
}

.uploader-file-size {
    display: none;
}

.uploader-btn {
    border: none
}

.uploader-drop {
    background: #fff;
    border: none
}

input.input_name {
    display: -webkit-box;
    margin-top: 22px;
    font-size: 14px;
    background: rgba(240, 240, 240, 1);
}

.outs {
    width: 22px;
    height: 22px;
    position: absolute;
    cursor: pointer;
    left: 192px;
    margin-top: -231px;
}

.maska {
    background-color: rgba(0, 0, 0, 0.4) !important;
    height: 164px;
    width: 164px;
    display: inline-block;
}

.martop50 {
    background: #f7f7f7;
    height: 400px;
    border: none;
    margin: 2px 0 20px 0;
    padding: 0px 40px;
}

.uploader-btn:hover {
    background: inherit;
}

video {
    border: none;
    height: 164px;
    width: 164px;
    object-fit: fill;
}

.upload-btnP {
    background: #EDEDED;
    width: 164px;
    height: 164px;
    text-align: center;
    margin: 30px 50px 80px 0px;
}

.upload-btnP img {
    width: 38px;
    height: 33px;
    margin-top: 50px;
}

.upload-btnP span {
    display: grid;
    color: #808080;
    font-size: 14px;
    margin-top: 17px;
}

input::-webkit-input-placeholder {
    font-size: 14px;
}

.uploadoKImg {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 10px;
    margin-top: 1px;
}

.uploadP {
    display: none;
    text-align: center;
}

//这里面可以自定义字体样式等，都是CSS基础
.rule {
    position: absolute;
    width: 0.82rem;
    height: 0.36rem;
    top: 0.08rem;
    right: 0rem;
    background: #111111;
}

.login {
    position: fixed;
    font-size: 24px;
    border-radius: 0.25rem;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 1000;
    color: #fff;
}

.over {
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.7; //透明度为70%
    filter: alpha(opacity=70);
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #111111;
}
</style>

